import {
    Component,
    ChangeDetectionStrategy,
    HostBinding,
    ViewEncapsulation,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    Output,
    EventEmitter,
    OnDestroy
} from '@angular/core';
import { UxAppShellService } from '@eui/core';
import { EuiMenuItem } from '../../../../components';
import { Subscription } from 'rxjs';

@Component({
    selector: 'eui-app-sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppSidebarMenuComponent implements OnInit, OnChanges, OnDestroy {
    @HostBinding() class = 'eui-app-sidebar-menu';

    @Input() items: any[];
    @Input() hasFilter = false;
    @Input() hasIcons = false;
    @Input() hasTooltip = false;
    @Input() expandAllItems = false;

    @Output() onSidebarItemClicked = new EventEmitter<EuiMenuItem>();
    private subs: Subscription;

    constructor(
        public asService: UxAppShellService,
    ) {
        this.subs = new Subscription();
    }

    ngOnInit() {
        this.asService.setState({
            ...this.asService.state,
            sidebarLinks: this.items,
        });

        // subscribe to state changes
        this.subs.add(this.asService.getState('sidebarLinks').subscribe(links => this.items = links));
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.items) {
            this.asService.setState({
                ...this.asService.state,
                sidebarLinks: this.items,
            });
        }
    }

    public onMenuItemClicked(event: EuiMenuItem) {
        // Auto-close sidebar menu after click when in mobile / tablet modes
        if (event.url &&
            (this.asService.state.breakpoints.isMobile
                || this.asService.state.breakpoints.isTablet
                || this.asService.state.isSidebarHidden)) {
            this.asService.isSidebarOpen = false;
        }

        this.onSidebarItemClicked.emit(event);
    }
}
